import { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { getSocket, disconnectSocket } from '../lib/socket';
import { useAuthStore } from '../store/authStore';
import { queryClient } from '../lib/queryClient';

type ForceLogoutReason =
  | { type: 'role_changed'; newRole: string }
  | { type: 'deactivated' };

export function useForceLogout() {
  const [reason, setReason] = useState<ForceLogoutReason | null>(null);
  const navigate = useNavigate();
  const logout = useAuthStore((s) => s.logout);

  useEffect(() => {
    const socket = getSocket();
    if (!socket) return;

    const handleRoleChanged = (data: { newRole: string }) => {
      setReason({ type: 'role_changed', newRole: data.newRole });
    };

    const handleDeactivated = () => {
      setReason({ type: 'deactivated' });
    };

    socket.on('role:changed', handleRoleChanged);
    socket.on('account:deactivated', handleDeactivated);

    return () => {
      socket.off('role:changed', handleRoleChanged);
      socket.off('account:deactivated', handleDeactivated);
    };
  }, []);

  const message = reason
    ? reason.type === 'role_changed'
      ? '관리자가 회원님의 권한을 변경했습니다. 다시 로그인해 주세요.'
      : '관리자가 회원님의 계정을 비활성화했습니다.'
    : '';

  const handleConfirm = useCallback(() => {
    disconnectSocket();
    logout();
    queryClient.clear();
    setReason(null);
    navigate('/login', { replace: true });
  }, [logout, navigate]);

  return { showModal: reason !== null, message, handleConfirm };
}
